import React from 'react';
import Repeat from 'react-repeat-component';

import styles from './MediaAboutUsPlaceholder.module.scss';

import { Container } from 'common/components/Layout/Layout';
import ContentBar from 'common/components/Placeholder/components/ContentBar/ContentBar';

const MediaAboutUsPlaceholder = () => (
  <Container className={styles.MediaAboutUsPlaceholder}>
    <div className={styles.ArticlesColumn}>
      <div className={styles.RecentArticles}>
        <Repeat times={6}>
          {i => (
            <ContentBar key={i} className={styles.MainArticlesPlaceholder} />
          )}
        </Repeat>
      </div>
    </div>
  </Container>
);

export default MediaAboutUsPlaceholder;



// WEBPACK FOOTER //
// ./src/views/MediaAboutUs/placeholder/MediaAboutUsPlaceholder.js